exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".borderless .list-group-item[data-v-47e11ace],.borderless td[data-v-47e11ace],.borderless th[data-v-47e11ace]{border:none}.order-activity .list-group .list-group-item[data-v-47e11ace]{border-left:none;border-right:none}.order-activity .list-group .list-group-item[data-v-47e11ace]:first-child{border-top:none}.order-activity .list-group .list-group-item[data-v-47e11ace]:last-child{border-bottom:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47e11ace","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Orders/Show.vue
// module id = uB9U
// module chunks = 1